/*eslint-disable */
import Vue from "vue";

const url = 'wss://'+ process.env.VUE_APP_WEBSOCKET_BASE_URL + '/ws/video-chat/';
let socket;

const emitter = new Vue({
  methods: {
    isOpen() {
      let status = '';
      if(socket && socket.readyState) {
        status = socket.readyState;
      }
      return status;
    },
    emit(message) {
      socket.send(JSON.stringify(message));
    },
    send(message) {
      if (1 === socket.readyState) socket.send(message);
    },
    close() {
      if (socket.readyState && 1 === socket.readyState) {
        emitter.$emit("close", JSON.stringify({message: 'Closing Chat', type: 'connectionClosed'}));
        socket.close();
        socket = null; // prevent memory leak
      }
    },
    connect(roomId) {
      socket = new WebSocket(url + roomId + "/");
      socket.onmessage = function(msg) {
        let message = JSON.parse(JSON.parse(msg.data).message);
        console.log(message);
        if(message.type === "videoCalling") {
          emitter.$emit("videoCallingNotification", message);
        }
        else if(message.type === 'videoCallAccepted') {
          emitter.$emit("videoCallAcceptedNotification", message);
        }
        else if(message.type === 'videoCallDecline') {
          emitter.$emit("videoCallDeclinedNotification", message);
        }
        else if(message.type === 'videoAlertPopupClose') {
          emitter.$emit("videoCallAlertPopupClosed", message);
        }
        else if(message.type === 'userLogin') {
          emitter.$emit("userLogin", message);
        }
        else if(message.type === 'userLogout') {
          emitter.$emit("userLogout", message);
        }
        else if(message.type === 'friendRequest') {
          emitter.$emit("friendRequest", message);
        }
        else if(message.type === 'newMessageNotification') {
          emitter.$emit("newMessageNotification", message);
        }
      };
      socket.onopen = function(event) {
        emitter.$emit("open", event);
        emitter.$emit("connection", JSON.stringify({message: 'connection created successfully', type: 'connection'}));
      };
      socket.onclose = function (event) {
        console.log('The Chat socket connection has been closed successfully');
      };
      socket.onerror = function(err) {
        emitter.$emit("error", err);
      };
    }
  }
});

export default emitter;
